module.exports = __webpack_public_path__ + "img/conference-2018.5ee3d05a.jpg";